import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { PathContextProvider } from '../../context/PathContext.js';
import { PathGraphFlowRunMode } from '../../generated/types.js';
import deriveNodeNavigationDetails from '../../helpers/deriveNodeNavigationDetails.js';
import PathFlow from '../PathFlow/index.js';

var Path = function Path(_ref) {
  var pathGraphFlowId = _ref.pathGraphFlowId,
      _ref$pathPlacement = _ref.pathPlacement,
      pathPlacement = _ref$pathPlacement === void 0 ? 'default' : _ref$pathPlacement,
      directedActiveNodeSlugOrId = _ref.directedActiveNodeSlugOrId,
      onActiveNodeUpdated = _ref.onActiveNodeUpdated,
      onPathCompleted = _ref.onPathCompleted,
      onRequestLogin = _ref.onRequestLogin;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      runMode = _useState2[0],
      setRunMode = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      pathGraphFlow = _useState4[0],
      setPathGraphFlow = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      pathGraphFlowErrors = _useState6[0],
      setPathGraphFlowErrors = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      nodeLevelErrors = _useState8[0],
      setNodeLevelErrors = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      activeNode = _useState10[0],
      setActiveNode = _useState10[1];

  return React.createElement(PathContextProvider, {
    value: {
      pathPlacement: pathPlacement,
      runMode: runMode,
      onSetRunMode: function onSetRunMode(updatedRunMode) {
        setRunMode(updatedRunMode);
      },
      pathGraphFlow: pathGraphFlow,
      onSetPathGraphFlow: function onSetPathGraphFlow(updatedPathGraphFlow) {
        setPathGraphFlow(updatedPathGraphFlow);
      },
      pathGraphFlowErrors: pathGraphFlowErrors,
      onSetPathGraphFlowErrors: function onSetPathGraphFlowErrors(updatedPathGraphFlowErrors) {
        setPathGraphFlowErrors(updatedPathGraphFlowErrors);
      },
      nodeLevelErrors: nodeLevelErrors,
      onSetNodeLevelErrors: function onSetNodeLevelErrors(updatedNodeLevelErrors) {
        setNodeLevelErrors(updatedNodeLevelErrors);
      },
      pathGraphFlowId: pathGraphFlowId,
      activeNode: activeNode,
      onSetActiveNode: function onSetActiveNode(updatedActiveNode) {
        var _a;

        setActiveNode(updatedActiveNode);
        /**
         * If the prop exists to notify outside of this component if the
         * node was updated, invoke it with the new id
         */

        if (onActiveNodeUpdated) {
          var activeNodeDetails = deriveNodeNavigationDetails(updatedActiveNode);
          onActiveNodeUpdated({
            nodeSlugOrId: activeNodeDetails.nodeSlug || activeNodeDetails.nodeId,
            pathGraphFlowSlug: activeNodeDetails.pathSlug,
            pathGraphFlowId: pathGraphFlowId
          });
        }

        setNodeLevelErrors([]);

        if ((pathGraphFlow === null || pathGraphFlow === void 0 ? void 0 : pathGraphFlow.runMode) !== PathGraphFlowRunMode.DRY_RUN && updatedActiveNode.id !== (activeNode === null || activeNode === void 0 ? void 0 : activeNode.id)) {
          (_a = window.tracking) === null || _a === void 0 ? void 0 : _a.events.trackPathClientFlowNodeViewed({
            path_graph_flow_id: pathGraphFlow === null || pathGraphFlow === void 0 ? void 0 : pathGraphFlow.id,
            navigation_direction: '',
            nodes: updatedActiveNode.references
          });
        }
      },
      onPathCompleted: onPathCompleted,
      onRequestLogin: onRequestLogin
    }
  }, React.createElement(PathFlow, {
    pathGraphFlowId: pathGraphFlowId,
    directedActiveNodeSlugOrId: directedActiveNodeSlugOrId
  }));
};

export default Path;
//# sourceMappingURL=index.js.map
